import * as React from "react";
import Typography from "@mui/material/Typography";
import * as constants from "../../../Components/constants";
import { Row, Col } from "react-bootstrap";
import Image from "next/image";
import Link from "next/link";
import { Avatar } from "@mui/material";

const baseURL = constants.BASE_URL;

const RelatedPost = ({ groupId, postId }) => {
  const [relatedPost, setRelatedPost] = React.useState([]);

  React.useEffect(() => {
    fetch(`${baseURL}/group/${groupId}/details/`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const posts = data.slice(0, 7);
        setRelatedPost(posts.filter((d) => d.id !== +postId));
      });
  }, [groupId, postId]);

  return (
    <React.Fragment>
      {relatedPost.map((post, idx) => (
        <React.Fragment key={idx}>
          {post.description && (
            <Row className="d-flex justify-content-center g-2 mb-2">
              {post.pic_upload && (
                <Col sm={5} md={5}>
                  <Link
                    passHref
                    href={{
                      pathname: `/post/${post.id}`,
                      query: {
                        keyword: `${
                          post.title_of_research_article ? "summary" : "thought"
                        }`,
                      },
                    }}
                  >
                    <a>
                      <Image
                        className="border rounded-2"
                        layout="responsive"
                        width={280}
                        height={160}
                        src={post.pic_upload}
                        alt={post.group}
                      />
                    </a>
                  </Link>
                </Col>
              )}
              <Col sm={post.pic_upload ? 7 : 12} md={post.pic_upload ? 7 : 12}>
                <div className="d-flex align-items-center pb-1">
                  <Link
                    href={
                      post.group_name
                        ? `/group/${post.group}`
                        : `/user/${post.user}`
                    }
                  >
                    <a target="_blank">
                      <Avatar
                        className="border me-2"
                        alt="Remy Sharp"
                        src={post.group_profile_pic}
                        sx={{ width: 35, height: 35 }}
                      />
                    </a>
                  </Link>

                  <Link
                    href={
                      post.group_name
                        ? `/group/${post.group}`
                        : `/user/${post.user}`
                    }
                  >
                    <a target="_blank" className="fw-bold">
                      {post.group_name}
                    </a>
                  </Link>
                </div>
                <Typography
                  variant="body2"
                  gutterBottom
                  sx={{ cursor: "pointer" }}
                >
                  <Link
                    passHref
                    href={{
                      pathname: `/post/${post.id}`,
                      query: {
                        keyword: `${
                          post.title_of_research_article ? "summary" : "thought"
                        }`,
                      },
                    }}
                  >
                    <span
                      dangerouslySetInnerHTML={{
                        __html: post.description.slice(0, 150),
                      }}
                    />
                  </Link>
                </Typography>
              </Col>
            </Row>
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

export default RelatedPost;
